<div id="toast-main-container" (mousedown)="onMouseDown()" (mouseup)="onMouseUp()" *ngIf="(toast.showsToast$ | async)" class="main-container" [ngStyle]="{'transform':toast.toastPosition$ | async}" [class]="toast.toastState$ | async">
    <div id="toast-content-container" class="content-container">
        <span id="toast-span">{{ toast.toastMessage$ | async }}</span>
    </div>
    <div id="toast-image-container" class="image-container">
        <img id="toast-img" [src]="getImageForToast()"  width="24" height="24" alt="toast"/>
    </div>
</div>
